import { render, staticRenderFns } from "./IconCircleXmark.vue?vue&type=template&id=46a97977&functional=true&"
import script from "./IconCircleXmark.vue?vue&type=script&lang=js&"
export * from "./IconCircleXmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports